<script module>
  export const meta = {
    title: 'New to Pausly',
    teaser:
      "We're thrilled you've decided to join us! At Pausly, our mission is\nstraightforward but vital: to help you incorporate regular breaks into your busy\nworkdays. But it's not just about stretching your legs or giving your eyes a\nrest from the computer screen. We believe breaks play a crucial role in\nmaintaining physical health, fostering social connections, and ensuring you stay\nin touch with colleagues and friends.",
    sort: 0,
  }
</script>

<p>
  In today's fast-paced world, taking a moment to pause can make all the
  difference. Let's embark on this journey together to create a more balanced,
  connected, and healthier work environment.
</p>
